var Filter = {
    element: null,
    elasticsearch: false,
    inputTags: ["select", "input"],
    skipSubmit: [],
    skipReset: ["view", "sort"],
    inputRegex: /filter\[(\w+)\]\[?\]?/,
    filterInputs: null,
    bubbles: null,
    selectors: {
        count: ".filter__count"
    },
    create: function (selector, options) {
        this.element = $(selector)[0];
        this.initialize();
        this.elasticsearch = $("body").hasClass("elastic-active");

        return this;
    },
    reset: function () {
        // reset inputs
        for (var i = 0; i < this.filterInputs.length; i++) {
            var input = this.filterInputs[i];

            if (_.indexOf(this.skipReset, this.inputKey(input.name)) != -1) {
                continue;
            }

            switch (input.tagName.toLowerCase()) {
                case "select":
                    var newIndex = -1;

                    $(input)
                        .find("option")
                        .each(function () {
                            if (!$(this).val()) {
                                newIndex = $(this).index();
                            }
                        });

                    input.selectedIndex = newIndex;
                    if ($(input).data("multiselect")) {
                        $(input)
                            .data("multiselect")
                            .refresh();
                    }
                    break;

                case "input":
                    switch (input.type.toLowerCase()) {
                        case "text":
                            input.value = "";
                            break;
                        case "password":
                        case "textarea":
                        case "hidden":
                        case "radio":
                            break;
                        case "checkbox":
                            if (input.checked) {
                                input.checked = false;
                            }
                            break;
                    }

                    break;
            }
        }

        // clear price inputs
        $('[name="filter[price][from]"]').val("");
        $('[name="filter[price][to]"]').val("");

        // reset ranges
        $('[name="filter[price][from]"]').prop("disabled", true);
        $('[name="filter[price][to]"]').prop("disabled", true);
        if ($("#price_range").hasClass("ui-slider")) {
            var slider = $("#price_range").data("uiSlider"),
                min = slider.option("min"),
                max = slider.option("max");

            slider.values([min, max]);
            slider.option("disabled", true);
        }

        // remove bubbles
        if (this.bubbles) {
            this.bubbles.remove();
        }

        // fetch data
        this.submit();

        rEvent.dispatch("Filter.reset");

        return false;
    },
    isFilterInput: function ($elem) {
        return $elem.attr("name") && this.inputKey($elem.attr("name"));
    },
    inputKey: function (field) {
        if (typeof field === 'undefined') {
            return false;
        }

        var matches = field.match(this.inputRegex);

        if (!matches) {
            return false;
        }

        return matches[1];
    },
    submitCallback: function (data) {
        $(Filter.selectors.count).html(data.count);

        Filter.refreshCounts(data);
        rEvent.dispatch("Filter.submited", data);
    },
    submit: function () {
        rEvent.dispatch("Filter.beforeSubmit");

        Listing.sendData(this.element, this.submitCallback);

        return false;
    },
    refreshCounts: function (data) {
        // resets
        $("[data-element='filterItemAggregation']").html(0);
        $("[data-element='filterItem'][data-count]").attr("data-count", 0);
        $(".filter__histogram .filter__histogram__col span").css("height", 0);

        if (data.aggregations) {
            for (var filterType in data.aggregations) {
                var aggregationSelector =
                    "[data-element='filterItemAggregation'][data-type='" +
                    filterType +
                    "']",
                    itemSelector =
                        "[data-element='filterItem'][data-type='" + filterType + "']";

                if (filterType == "properties" || filterType == "variations") {
                    $(itemSelector).attr("data-count", 0);
                    $(aggregationSelector).attr("data-count", 0);

                    for (var groupId in data.aggregations[filterType]) {
                        for (var value in data.aggregations[filterType][groupId]) {
                            var count = data.aggregations[filterType][groupId][value],
                                itemValue =
                                    "[data-field-value='" +
                                    groupId +
                                    ";" +
                                    value.replace("'", "\\'") +
                                    "']";

                            $(aggregationSelector + itemValue).html(count);
                            $(itemSelector + itemValue).attr("data-count", count);
                        }
                    }
                } else if (filterType == "prices" && data.config.updatePriceInputs) {
                    var $aggregation = data.aggregations[filterType],
                        $priceFromInput = $('input[name="filter[price][from]"]'),
                        $priceToInput = $('input[name="filter[price][to]"]'),
                        $priceRange = $("#price_range");

                    if ($priceFromInput.length) {
                        var isPriceFromDisabled = $priceFromInput[0].hasAttribute(
                            "data-update-disabled"
                        );

                        $priceFromInput.prop("disabled", false);

                        if (
                            $priceFromInput.val() != $aggregation.actualMinPrice &&
                            !isPriceFromDisabled
                        ) {
                            $priceFromInput
                                .attr("data-min", $aggregation.actualMinPrice)
                                .data("min", $aggregation.actualMinPrice);

                            if (
                                $priceFromInput.val() == "" ||
                                parseInt($priceFromInput.val()) < $aggregation.actualMinPrice
                            ) {
                                $priceFromInput
                                    .val($aggregation.actualMinPrice)
                                    .trigger("change");
                                $priceFromInput.attr("placeholder", $priceFromInput.val());
                            }
                        }
                    }

                    if ($priceToInput.length) {
                        var isPriceToDisabled = $priceToInput[0].hasAttribute(
                            "data-update-disabled"
                        );

                        $priceToInput.prop("disabled", false);

                        if (
                            $priceToInput.val() != $aggregation.actualMaxPrice &&
                            !isPriceToDisabled
                        ) {
                            $priceToInput
                                .attr("data-max", $aggregation.actualMaxPrice)
                                .data("max", $aggregation.actualMaxPrice)
                                .attr("placeholder", $aggregation.actualMaxPrice);

                            if (
                                $priceToInput.val() == "" ||
                                parseInt($priceToInput.val()) > $aggregation.actualMaxPrice
                            ) {
                                $priceToInput
                                    .val($aggregation.actualMaxPrice)
                                    .trigger("change");
                                $priceToInput.attr("placeholder", $priceToInput.val());
                            }
                        }
                    }

                    // only for ui-slider
                    if ($priceRange.size() > 0 && $priceRange.hasClass("ui-slider")) {
                        $priceRange.data("uiSlider").option("disabled", false);

                        $priceRange.slider("option", "min", $aggregation.actualMinPrice);
                        $priceRange.slider("option", "max", $aggregation.actualMaxPrice);

                        if (
                            parseInt($priceFromInput.val()) != $priceRange.slider("values", 0)
                        ) {
                            $priceRange.slider("values", 0, parseInt($priceFromInput.val()));
                        }
                        if (
                            parseInt($priceToInput.val()) != $priceRange.slider("values", 1)
                        ) {
                            $priceRange.slider("values", 1, parseInt($priceToInput.val()));
                        }
                    }

                    // only for histogram
                    for (var i in $aggregation["levels"]) {
                        var priceRange = $aggregation["levels"][i],
                            $elem = $(
                                ".filter__histogram .filter__histogram__col:eq(" + i + ")"
                            );

                        $elem
                            .find("a")
                            .attr("data-count", priceRange.count)
                            .attr("data-from", priceRange.min)
                            .attr("data-to", priceRange.max)
                            .find("span")
                            .css("height", priceRange.percentage + "%");
                    }

                    rEvent.dispatch("Filter.prices.updated", $aggregation);
                } else {
                    for (var id in data.aggregations[filterType]) {
                        var value = data.aggregations[filterType][id],
                            itemValue = "[data-field-value='" + id.replace("'", "\\'") + "']";

                        $(aggregationSelector + itemValue).html(value);
                        $(itemSelector + itemValue).attr("data-count", value);
                    }
                }
            }
        }
    },
    refreshBubbles: function () {
        $(this.element)
            .find(this.inputTags.join())
            .each(function () {
                if (
                    !Filter.isFilterInput($(this)) ||
                    _.indexOf(Filter.skipSubmit, Filter.inputKey($(this).attr("name"))) !=
                    -1
                ) {
                } else {
                    if (Filter.bubbles) {
                        Filter.bubbles.refresh($(this));
                    }
                }
            });
    },
    initialize: function () {
        var $filter = $(this.element);

        this.filterInputs = $filter.find(this.inputTags.join()).filter(function () {
            return this.name.match(Filter.inputRegex);
        });

        // change filter input
        $filter.find(this.inputTags.join()).bind("change", function () {
            var $this = $(this),
                inputName = Filter.inputKey($this.attr("name"));

            if (
                !Filter.isFilterInput($(this)) ||
                _.indexOf(Filter.skipSubmit, inputName) != -1
            ) {
                return;
            }

            if (Filter.bubbles) {
                Filter.bubbles.refresh($this);
            }

            if ($this.attr("data-nosubmit") == 1) {
                return;
            }

            if (inputName == "view") {
                var viewValue = $this.val();

                if ($this.attr("type") == "radio") {
                    viewValue = $('input[name="filter[view]"]:checked').val();
                }
                setCookie("listingView", viewValue);
                rEvent.dispatch("Listing.changeView");

                return;
            }

            $filter.trigger("submit");
        });

        // submit filter
        $filter.bind("submit", function () {
            return Filter.submit();
        });

        // reset filter
        $filter.find('[type="reset"]').bind("click", function () {
            return Filter.reset();
        });
    }
};

var FilterBubbles = {
    template: "",
    skipBubbles: ["sort", "view", "price"],
    container: ".filter__bubbles",
    holder: ".filter__bubbles__item",
    create: function (filterSelector, options) {
        this.template = options.template;

        this.initialize();

        return this;
    },
    add: function (data) {
        if (!data.content) {
            return;
        }

        $(this.container).append(_.template(this.template)(data));
        $('[data-element="filterBubbles"]').attr(
            "data-count",
            $(".filter__bubbles__item").size()
        );
    },
    exists: function (key, value) {
        return (
            $(
                this.holder +
                '[data-filter-key="' +
                key +
                '"][data-filter-value="' +
                encodeURIComponent(value) +
                '"]'
            ).size() > 0
        );
    },
    get: function (key, value) {
        return Filter.filterInputs.filter(function () {
            switch (this.tagName.toLowerCase()) {
                case "select":
                    return this.name == key;

                case "input":
                    return this.name == key && this.value == value;
            }
        });
    },
    getText: function (key, value) {
        var inputs = this.get(key, value),
            input = inputs[0];
        if (!input) {
            return "";
        }

        switch (input.tagName.toLowerCase()) {
            case "select":
                return $(input)
                    .find('option').filter(function () {
                        return $(this).val() == value;
                    }).eq(0)
                    .text();

            case "input":
                var $label = $(input)
                    .parents(".form-group")
                    .find("label");
                if (!$label.size()) {
                    $label = $(input).parents("label");
                }
                if (!$label.size()) {
                    $label = $(input).next("label");
                }

                return $label
                    .clone()
                    .find(".filter__content__count")
                    .remove()
                    .end()
                    .text();
        }
    },
    refresh: function ($elem) {
        var value = $elem.val(),
            field = Filter.inputKey($elem.attr("name")),
            fieldName = $elem.attr("name"),
            $bubbles = $(this.holder + '[data-filter-key="' + fieldName + '"]');

        if (
            $elem[0].tagName.toLowerCase() == "input" &&
            $elem[0].type.toLowerCase() == "checkbox"
        ) {
            value = [];
            $('[name="' + $elem.attr("name") + '"]:checked').each(function () {
                value.push($(this).val());
            });
        }
        else if (
            $elem[0].tagName.toLowerCase() == "input" &&
            $elem[0].type.toLowerCase() == "radio"
        ) {
            value = $('[name="' + $elem.attr("name") + '"]:checked').val();
        }

        // remove bubbles
        $bubbles.remove();
        $('[data-element="filterBubbles"]').attr(
            "data-count",
            $(".filter__bubbles__item").size()
        );

        if (!value || _.indexOf(this.skipBubbles, field) != -1) {
            rEvent.dispatch("FilterBubbles.returnedRefresh");

            return;
        }

        // add bubbles
        if (value instanceof Array) {
            for (var i = 0; i < value.length; i++) {
                if (!this.exists(field, value[i])) {
                    this.add({
                        url: "#",
                        _class: field,
                        key: fieldName,
                        value: encodeURIComponent(value[i]),
                        content: this.getText(fieldName, value[i])
                    });
                }
            }
        } else {
            if (!this.exists(field, value)) {
                this.add({
                    url: "#",
                    _class: field,
                    key: fieldName,
                    value: encodeURIComponent(value),
                    content: this.getText(fieldName, value)
                });
            }
        }

        rEvent.dispatch("FilterBubbles.afterRefresh");
    },
    remove: function () {
        $(this.holder).remove();
    },
    initialize: function () {
        var $this = this;

        $("body").delegate(this.holder, "click", function () {
            var $elem = $(this),
                field = $elem.data("filter-key"),
                value = decodeURIComponent($elem.data("filter-value")),
                inputs = $this.get(field, value);

            for (var i = 0; i < inputs.length; i++) {
                var input = inputs[i];

                switch (input.tagName.toLowerCase()) {
                    case "select":
                        $(input)
                            .find('option').filter(function () {
                                return $(this).val() == value;
                            }).eq(0)
                            .prop("selected", false);
                        if ($(input).data("multiselect")) {
                            $(input)
                                .data("multiselect")
                                .refresh();
                        }
                        break;

                    case "input":
                        switch (input.type.toLowerCase()) {
                            case "text":
                            case "password":
                            case "textarea":
                            case "hidden":
                                input.value = "";
                                break;
                            case "radio":
                            case "checkbox":
                                if (input.checked) {
                                    input.checked = false;
                                }
                                break;
                        }
                        break;
                }
            }

            Filter.submit();
            $elem.remove();
            $('[data-element="filterBubbles"]').attr(
                "data-count",
                $(".filter__bubbles__item").size()
            );

            return false;
        });
    }
};

rEvent.on("Filter.reset", function () {
    $('[name="filter[price][from]"]').prop("disabled", false);
    $('[name="filter[price][to]"]').prop("disabled", false);
    if ($("#price_range").hasClass("ui-slider")) {
        $("#price_range")
            .data("uiSlider")
            .option("disabled", false);
    }
});
